import { Injectable } from '@angular/core';
import { UtilidadesService } from '../utilidades.servicios.index';
import { Observable } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class PadronService {

	constructor(
		private Utilidades: UtilidadesService
	) {
	}

	public Obtener(tipoDocumento: number, nroDocumento: number): Observable<any> {
		return this.Utilidades.Get("Externos/Padron/Obtener/" + tipoDocumento + "/" + nroDocumento);
	}
}